import React from 'react';
import { Layout } from 'antd';
import { useSelector } from 'react-redux';

import logoSymbol from 'assets/PS_logo_symbol-black.svg';
import logoText from 'assets/PS_logo_textonly-white.svg';
import { RootState } from 'store';
import BaseLayoutSideNav from '../baseLayoutSideNav/BaseLayoutSideNav';

import './BaseLayoutSideBar.scss';

const { Sider } = Layout;

function BaseLayoutSideBar() {
  const { sideBarCollapsed, sideBarWidth, sideBarCollapsedWidth } = useSelector(
    (state: RootState) => state.baseLayoutSettings
  );

  return (
    <Sider
      className="LayoutSideBar"
      theme="light"
      trigger={null}
      collapsible
      collapsed={sideBarCollapsed}
      collapsedWidth={sideBarCollapsedWidth}
      width={sideBarWidth}
    >
      <section className="LayoutSideBar__logo">
        <img
          className="LayoutSideBar__logo__symbol"
          src={logoSymbol}
          alt="PET"
        />
        <span className="LayoutSideBar__logo__text-only logoTextOnly">
          <img src={logoText} alt="PuppySpot" />
        </span>
      </section>
      <BaseLayoutSideNav />
    </Sider>
  );
}

export default BaseLayoutSideBar;
